import { create } from 'zustand';
import {
  createJSONStorage,
  persist,
  subscribeWithSelector,
} from 'zustand/middleware';

interface ITrackingUserParams {
  stag?: string | null;
  utm_source?: string | null;
  utm_medium?: string | null;
  utm_campaign?: string | null;
  utm_content?: string | null;
  utm_term?: string | null;
  ref_code?: string | null;
  promo_id?: string | null;
  campaign_id?: string | null;
  app_id?: string;
  pwa_id?: string;
  source?: string | null;
}

interface ITrackingUserParamsStore extends ITrackingUserParams {
  setTrackingUserParams: (params: ITrackingUserParams) => void;
  resetCampaignParams: () => void;
}

/**
 * `undefined`, not `null`: `partialize` drops those keys from localStorage, matching a fresh store.
 * `stag`/`ref_code` stay — a registered browser never gets them re-sent, so a reset is permanent.
 * `app_id`, `pwa_id` and `source` identify the install, not the account.
 */
const RESET_CAMPAIGN_PARAMS: ITrackingUserParams = {
  utm_source: undefined,
  utm_medium: undefined,
  utm_campaign: undefined,
  utm_content: undefined,
  utm_term: undefined,
  campaign_id: undefined,
  promo_id: undefined,
};

export const useTrackingUserParamsStore = create<ITrackingUserParamsStore>()(
  subscribeWithSelector(
    persist(
      (set) => ({
        setTrackingUserParams: (params) => {
          set({ ...params });
        },
        resetCampaignParams: () => {
          set({ ...RESET_CAMPAIGN_PARAMS });
        },
      }),
      {
        name: 'tracking-user-params',
        storage: createJSONStorage(() => localStorage),
        partialize: (state) => ({
          stag: state.stag,
          campaign_id: state.campaign_id,
          promo_id: state.promo_id,
          pwa_id: state.pwa_id,
          app_id: state.app_id,
          source: state.source,
        }),
      }
    )
  )
);
